const projectData = [{
    id:1,
    title: 'Secure Data Certificate Format Converter (SDCFC)',
    description: ' Secure Data Certificate Format Converter (SDCFC) is a powerful tool for managing certificate and private key files, offering seamless conversion between PEM, DER, and PKCS12 formats. Whether you need to generate, convert, or manage certificates, SD-CFC provides a user-friendly interface to streamline your workflow securely.',
    owner: 'Subham Divakar(Me)',
    startDate: '2024-01-01',
    endDate: 'Constantly Improving',
    skills: ['Python'],
    links: {
      youtube: 'https://www.youtube.com/watch?v=GkFWvz0an48', // Replace with your actual YouTube video URL
      github: 'https://github.com/shubham10divakar/sdcfc', // Replace with your actual GitHub repository URL
      pip:'https://pypi.org/project/sdcfc/',
    },
    installation: 'You can install this project using pip. Run the following command:\n\n```pip install sdcfc```',
    usageExamples: [
      {
        title: 'Example 1',
        description: 'Install using pip and triger the main menu',
        code: ' import sdcfc\n #Now you can use functions or classes defined in sdfc module\n sdcfc.main()',
      },
      {
        title: 'Example 2',
        description: 'OR use you can specific functions as well',
        code: 'Check pypi link',
      },
    ],
    features: [
      'Convert PEM to DER',
    'Convert DER to PEM',
    'Convert PEM to PKCS#12',
    'Convert PKCS#12 to PEM',
    'Convert DER to PKCS#12'

    ],
    contributing: 'Thank you for considering contributing to our project! Please read our [Contributing Guidelines](link-to-contributing-docs) for details on how to get started.',
    communityLinks: {
      forum: 'Link to community forum or mailing list',
      support: 'Link to support channel or FAQ page',
    },
    acknowledgments: 'We acknowledge the contributions of individuals or organizations that have helped make this project possible.',
    screenshots: [
      'URL to screenshot or demo GIF 1',
      'URL to screenshot or demo GIF 2',
    ],
  }, 
  {
    id : 2,
    title: 'Secure Data SSL Certificate Management Tool',
    description: 'Secure Data SSL Certificate Management Tool (SDSCMT) is a powerful tool for generating and managing self signed ssl certificates and private key files, offering seamless conversion between PEM, DER, and PKCS12 formats as well. Whether you need to generate, convert, or manage self signed ssl certificates, SDSCMT provides a user-friendly interface to get the job done.',
    owner: 'Me',
    startDate: '2024-01-01',
    endDate: 'Currently Ongoing',
    skills: ['Python'],
    links: {
      youtube: 'https://www.youtube.com/watch?v=GkFWvz0an48', // Replace with your actual YouTube video URL
      github: 'https://github.com/shubham10divakar/sdscmt', // Replace with your actual GitHub repository URL
      pip:'https://pypi.org/project/sdscmt/',
    },
    installation: 'You can install this project using pip. Run the following command:\n\n```pip install sdscmt```',
    usageExamples: [
      {
        title: 'Example 1',
        description: 'Install using pip and triger the main menu',
        code: ' import sdscmt\n #Now you can use functions or classes defined in sdscmt module\n sdscmt.main()',
      },
      {
        title: 'Example 2',
        description: 'OR use you can specific functions as well',
        code: 'Check pypi link',
      },
    ],
    features: [
      'Generate Self Signed Certificates',
      'Validate existing self signed ssl certs',
      'Convert PEM to DER',
      'Convert DER to PEM',
      'Convert PEM to PKCS#12',
      'Convert PKCS#12 to PEM',
      'Convert DER to PKCS#12',

    ],
    contributing: 'Thank you for considering contributing to our project! Please read our [Contributing Guidelines](link-to-contributing-docs) for details on how to get started.',
    communityLinks: {
      forum: 'Link to community forum or mailing list',
      support: 'Link to support channel or FAQ page',
    },
    acknowledgments: 'We will acknowledge the contributions of individuals  that will help to make this project possible.',
    screenshots: [
      'URL to screenshot or demo GIF 1',
      'URL to screenshot or demo GIF 2',
    ],
  }];


  export default projectData;